// 加载全局组件
import VChart from 'vue-echarts'
import 'echarts'

// 加载全局样式
import '@/assets/style/app.css';
import 'element-ui/lib/theme-chalk/index.css';

export default {
    install(Vue){
        // 设置为 false 以阻止 vue 在启动时生成生产提示。
        // https://cn.vuejs.org/v2/api/#productionTip
        Vue.config.productionTip = false

        // 当前环境
        Vue.prototype.$env = process.env.NODE_ENV

        // 当前的 baseUrl
        Vue.prototype.$baseUrl = process.env.BASE_URL
        Vue.prototype.$basePath = process.env.VUE_APP_API

        // 注册组件
        Vue.component('v-chart', VChart)
    }
}